import React from 'react';
import { useParams } from 'react-router-dom';
import { NeedFromAbby } from '../components/NeedFromAbby';
import { Button } from '../components/Button';
import { usePageMeta } from '../hooks/usePageMeta';
import { disclaimer } from '../data/site';
const PAGES: Record<string, {
  title: string;
  intro: string;
}> = {
  privacy: {
    title: 'Privacy Policy',
    intro: 'How True Twelve collects, uses and protects your information, including email and SMS preferences.'
  },
  terms: {
    title: 'Terms of Service',
    intro: 'The terms that apply to purchases, readings and use of this website.'
  },
  'shipping-returns': {
    title: 'Shipping & Returns',
    intro: 'Delivery times, shipping regions and how to return a piece.'
  },
  disclaimer: {
    title: 'Disclaimer',
    intro: disclaimer
  }
};
export function Legal() {
  const {
    page = ''
  } = useParams();
  const content = PAGES[page];
  usePageMeta(content?.title ?? 'Page not found', content?.intro ?? 'This page could not be found.');
  if (!content) {
    return <section className="gutter section text-center" data-id="element-786" data-mp="27kd6ottj0h6c">
        <h1 className="t-h2" data-id="element-787" data-mp="27n7pyi0szvy6">Page not found.</h1>
        <Button to="/" className="mt-8" data-id="element-788" data-mp="23kb1wbshv7mu">
          Return Home
        </Button>
      </section>;
  }
  return <section aria-labelledby="legal-title" className="gutter py-[clamp(3rem,7vw,8rem)]" data-id="element-789" data-mp="2hhzpvshuyuw4">
      <div className="mx-auto max-w-[70ch]" data-id="element-790" data-mp="2cl9bd9lpc7ct">
        <p className="t-label text-graphite" data-id="element-791" data-mp="2ciepreqycght">Legal</p>
        <h1 id="legal-title" className="t-h2 mt-5" data-id="element-792" data-mp="1ovoo4eiimnxq">
          {content.title}
        </h1>
        <p className="t-lead mt-6 text-graphite" data-id="element-793" data-mp="1jwbtv8pbeel4">{content.intro}</p>
        <NeedFromAbby className="mt-8" data-id="element-794" data-mp="1ykgfakfr547l">{content.title.toLowerCase()} wording</NeedFromAbby>
      </div>
    </section>;
}